import API from '@/services/api'

// Actions
export const FETCH_SCHEDULES_WIDGET = 'fetchSchedulesWidget'
export const FETCH_SCHEDULES = 'fetchSchedules'
export const FETCH_DOING_SCHEDULES = 'fetchDoingSchedules'
export const FETCH_FINISHED_SCHEDULES = 'fetchFinishedSchedules'

export const FETCH_SCHEDULE = 'fetchSchedule'
export const CREATE_SCHEDULE = 'createSchedule'
export const UPDATE_SCHEDULE = 'updateSchedule'
export const DELETE_SCHEDULE = 'deleteSchedule'

// Mutations
export const STORE_SET_SCHEDULES = 'storeSetSchedules'
export const STORE_SET_SCHEDULES_WIDGET = 'storeSetSchedulesWidget'
export const STORE_SET_DOING_SCHEDULES = 'storeSetDoingSchedules'
export const STORE_SET_FINISHED_SCHEDULES = 'storeSetFinishedSchedules'

export const STORE_ADD_SCHEDULE = 'storeAddSchedule'
export const STORE_UPDATE_SCHEDULE = 'storeUpdateSchedule'
export const STORE_DELETE_SCHEDULE = 'storeDeleteSchedule'

// Only the latest request per list may update it, so slow responses for older search terms are ignored
const latestRequests = {}

function scheduleQuery (resource, options) {
	let query = resource + '?page=' + options.page

	if (options.search) {
		query += '&search=' + encodeURIComponent(options.search)
	}

	return query
}

const state = {
	schedulesWidget: {
		data: [],
		meta: {
			total: 0,
			per_page: 15,
			from: 1,
			to: 0,
			current_page: 1
		}
	},
	schedules: {
		data: [],
		meta: {
			total: 0,
			per_page: 15,
			from: 1,
			to: 0,
			current_page: 1
		}
	},
	doingSchedules: {
		data: [],
		meta: {
			total: 0,
			per_page: 15,
			from: 1,
			to: 0,
			current_page: 1
		}
	},
	finishedSchedules: {
		data: [],
		meta: {
			total: 0,
			per_page: 15,
			from: 1,
			to: 0,
			current_page: 1
		}
	},
}

const getters = {
	schedules (state) {
		return state.schedules
	},
	schedulesWidget (state) {
		return state.schedulesWidget
	},
	doingSchedules (state) {
		return state.doingSchedules
	},
	finishedSchedules (state) {
		return state.finishedSchedules
	},
}

const actions = {
	[FETCH_SCHEDULES_WIDGET] (context, page) {
		return new Promise((resolve, reject) => {
			API.query('schedule/widget?page=' + page).then((response) => {
				context.commit(STORE_SET_SCHEDULES_WIDGET, response.data)
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
	[FETCH_SCHEDULES] (context, options) {
		const request = latestRequests[FETCH_SCHEDULES] = (latestRequests[FETCH_SCHEDULES] || 0) + 1

		return new Promise((resolve, reject) => {
			API.query(scheduleQuery('schedule', options)).then((response) => {
				if (request === latestRequests[FETCH_SCHEDULES]) {
					context.commit(STORE_SET_SCHEDULES, response.data)
				}
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
	[FETCH_DOING_SCHEDULES] (context, options) {
		const request = latestRequests[FETCH_DOING_SCHEDULES] = (latestRequests[FETCH_DOING_SCHEDULES] || 0) + 1

		return new Promise((resolve, reject) => {
			API.query(scheduleQuery('schedule/doing', options)).then((response) => {
				if (request === latestRequests[FETCH_DOING_SCHEDULES]) {
					context.commit(STORE_SET_DOING_SCHEDULES, response.data)
				}
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
	[FETCH_FINISHED_SCHEDULES] (context, options) {
		const request = latestRequests[FETCH_FINISHED_SCHEDULES] = (latestRequests[FETCH_FINISHED_SCHEDULES] || 0) + 1

		return new Promise((resolve, reject) => {
			API.query(scheduleQuery('schedule/finished', options)).then((response) => {
				if (request === latestRequests[FETCH_FINISHED_SCHEDULES]) {
					context.commit(STORE_SET_FINISHED_SCHEDULES, response.data)
				}
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
	[FETCH_SCHEDULE] (context, schedule) {
		return new Promise((resolve, reject) => {
			API.query('schedule/' + schedule).then((response) => {
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
	[CREATE_SCHEDULE] (context, schedule) {
		return new Promise((resolve, reject) => {
			API.post('objects/' + schedule.object + '/schedule', schedule.data).then((response) => {
				context.commit(STORE_ADD_SCHEDULE, response.data);
				resolve(response.data)
			}).catch(({ response }) => {
				reject(response.data)
			})
		})
	},
	[UPDATE_SCHEDULE] (context, schedule) {
		return new Promise((resolve, reject) => {
			API.update('schedule', schedule.id, schedule.changes).then((response) => {
				context.commit(STORE_UPDATE_SCHEDULE, response.data)
				resolve(response.data)
			}).catch(({ response }) => {
				reject(response.data)
			})
		})
	},
	[DELETE_SCHEDULE] (context, schedule) {
		return new Promise((resolve, reject) => {
			API.delete('objects/' + schedule.object + '/schedule/' + schedule.inspection ).then((response) => {
				context.commit(STORE_DELETE_SCHEDULE, schedule)
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
}

const mutations = {
	[STORE_SET_SCHEDULES] (state, schedules) {
		state.schedules = schedules
	},
	[STORE_SET_SCHEDULES_WIDGET] (state, schedules) {
		state.schedulesWidget = schedules
	},
	[STORE_SET_DOING_SCHEDULES] (state, schedules) {
		state.doingSchedules = schedules
	},
	[STORE_SET_FINISHED_SCHEDULES] (state, schedules) {
		state.finishedSchedules = schedules
	},
	[STORE_ADD_SCHEDULE] (state, schedule) {
		state.schedules.data.push(schedule)
	},
	[STORE_UPDATE_SCHEDULE] (state, schedule) {
		let schedules = []

		state.schedules.data.map((mapSchedule) => {
			if (mapSchedule.id === schedule.id) {
				mapSchedule = schedule
			}

			schedules.push(mapSchedule)
		})

		state.schedules.data = schedules
	},
	[STORE_DELETE_SCHEDULE] (state, schedule) {
		state.schedules.data.splice(state.schedules.data.indexOf(schedule), 1)
	},
}

export default { state, getters, actions, mutations }